<template>
  <div class="app-modal-field full-width" data-focus-field="customer">
    <AppInlineCustomerSelector
      v-model="form.customer"
      label="Cliente *"
      placeholder="Buscar cliente"
      :has-error="hasCustomerError"
      :error-message="customerErrorMessage"
    />
  </div>
</template>

<script>
import AppInlineCustomerSelector from '@/components/common/selectors/AppInlineCustomerSelector.vue';

export default {
  name: 'SaleModalSingleCustomerField',
  components: {
    AppInlineCustomerSelector,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasCustomerError() {
      return Boolean(this.v$?.form?.customer?.$error);
    },
    customerErrorMessage() {
      const firstError = this.v$?.form?.customer?.$errors?.[0];
      return firstError?.$message || 'Selecciona un cliente.';
    },
  },
};
</script>
